module.exports = __webpack_public_path__ + "presenter1-7a6b62b572fa8df00ac2bb7524ad2de5.jpg";